<template>
  <div class="optionBox">
    <el-dialog
      :title="$fanyi('附加服务')"
      :visible.sync="show"
      width="1344px"
      :before-close="handleClose"
      class="onDialogBox"
      append-to-body
    >
      <div class="diaCon">
        <div class="diaMain">
          <div class="optionListBox">
            <div
              v-for="(optionListitem, index) in orderParent.optionList"
              :key="'optionsList' + index"
            >
              <div
                class="optionOpt"
                :class="{
                  'is-checked': optionListitem.checked,
                  'is-last-active':
                    lastActiveOption &&
                    lastActiveOption.id === optionListitem.id,
                }"
                @click="onOptionCardClick(optionListitem)"
              >
                <div class="headBox">
                  <el-checkbox
                    :disabled="!canEdit"
                    v-model="optionListitem.checked"
                    class="uiCheckbox optionCheckInput"
                    @click.native.stop
                    @change="onOptionCheckChange(optionListitem)"
                  ></el-checkbox>
                  <span class="optionNameBox">{{
                    $fun.optionDisplayName(optionListitem)
                  }}</span>
                  <el-popover
                    v-if="optionListitem.id == 13"
                    placement="top"
                    trigger="hover"
                  >
                    <div class="optionPrement">
                      <h3>{{ $fanyi("标签为亚马逊FBA") }}</h3>
                      <p>
                        {{
                          $fanyi(
                            "亚马逊FBA的标签是免费的，只要程序是由制造商负责。",
                          )
                        }}
                      </p>
                      <p>
                        {{
                          $fanyi(
                            "如果程序是由Rakumart执行的，则将收取“SKU标签”服务费用。",
                          )
                        }}
                      </p>
                    </div>
                    <img
                      slot="reference"
                      class="infoIcon"
                      :src="require('@/assets/icon/info_fill.svg')"
                      alt=""
                      @click.stop="onInfoIconClick(optionListitem)"
                    />
                  </el-popover>
                  <el-popover
                    v-if="optionListitem.id == 12"
                    placement="top"
                    trigger="hover"
                  >
                    <div class="optionPrement">
                      <h3>{{ $fanyi("亚马逊FBA套装包装") }}</h3>
                      <p>
                        {{
                          $fanyi(
                            "为亚马逊FBA免费打包产品，只要程序由制造商负责。",
                          )
                        }}
                      </p>
                      <p>
                        {{
                          $fanyi(
                            "如果该程序是由Rakumart执行的，则将收取“捆绑”服务费用。",
                          )
                        }}
                      </p>
                    </div>
                    <img
                      slot="reference"
                      class="infoIcon"
                      :src="require('@/assets/icon/info_fill.svg')"
                      alt=""
                      @click.stop="onInfoIconClick(optionListitem)"
                    />
                  </el-popover>
                </div>
              </div>
              <div class="quantityRow" @click.stop>
                <template v-if="optionListitem.checked">
                  <span class="quantityLabel">{{ $fanyi("数量") }}:</span>
                  <el-input-number
                    size="mini"
                    :min="1"
                    :disabled="!canEdit"
                    @input="setNumber($event, optionListitem)"
                    @change="orderParent.setOneGoodsOptionTotalPrice()"
                    v-model="optionListitem.num"
                    class="uiInput"
                  ></el-input-number>
                </template>
              </div>
            </div>
          </div>

          <div class="previewPanel">
            <template v-if="lastActiveOption">
              <div class="previewMedia">
                <el-carousel
                  height="280px"
                  indicator-position="none"
                  :autoplay="false"
                  :arrow="activeImage && activeVideo ? 'always' : 'hover'"
                >
                  <el-carousel-item>
                    <img
                      :src="activeImage || emptyImageSrc"
                      class="previewImg"
                      :class="{ 'previewImg--placeholder': !activeImage }"
                      alt=""
                    />
                  </el-carousel-item>
                  <el-carousel-item>
                    <iframe
                      v-if="activeVideo"
                      class="previewVideo"
                      :src="activeVideo"
                      title="video"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    ></iframe>
                    <img
                      v-else
                      :src="emptyVideoSrc"
                      class="previewImg previewImg--placeholder"
                      alt=""
                    />
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="previewInfo">
                <div class="previewTitle">
                  <span>{{ active_name_translate }}</span>
                  <img
                    v-if="showInfoIcon(lastActiveOption)"
                    class="infoIcon"
                    :src="require('@/assets/icon/info_fill.svg')"
                    alt=""
                  />
                </div>
                <div class="previewPrice">
                  {{ $fanyi("单价") }}:
                  <span class="priceEur">{{ unitPriceEur }}€</span>
                  <span class="priceRmb">({{ unitPriceRmb }}￥)</span>
                </div>
              </div>
            </template>
            <div v-else class="previewPlaceholder"></div>
          </div>
        </div>

        <div class="diaFooter">
          <!-- 我们的专业顾问将与您联系，审核您的申请，并在必要时与您沟通细节。 -->
          <p class="footerTip">
            {{
              $fanyi("我们的专业顾问将与您联系，审核您的申请，并在必要时与您沟通细节。")
            }}
          </p>
          <div class="footerRight">
            <!-- 预估总计（元） -->
            <div class="footerTotal">
              {{ $fanyi("预估总计（元）") }}：<span>{{ totalPriceEur }}€</span>
            </div>
            <div class="footerBtns" v-if="canEdit">
              <el-button
                class="btnCancel uiBtn uiFontGreen"
                @click="handleClose()"
                >{{ $fanyi("关闭") }}</el-button
              >
              <el-button
                type="primary"
                class="btnSave uiBtn"
                @click="saveOrderOption()"
                >{{ $fanyi("保存") }}</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import odata from "@/utlis/allImportData.js";
export default {
  data() {
    return {
      show: false,
      parentData: {},
      optionIntroduction: odata.optionIntroduction,
      lastActiveOption: null,
      activeVideo: "",
      activeImage: "",
      active_name_translate: "",
      emptyImageSrc: require("@/assets/UserCenter/option/option-empty-image.png"),
      emptyVideoSrc: require("@/assets/UserCenter/option/option-empty-video.svg"),
    };
  },
  computed: {
    orderParent() {
      return this.$parent.$parent;
    },
    canEdit() {
      let orderstatus = this.orderParent.orderStatus;
      return orderstatus == "temporary" || orderstatus == "editing";
    },
    exchangeRate() {
      return (
        (this.orderParent.datas && this.orderParent.datas.exchange_rate) || 1
      );
    },
    unitPriceEur() {
      if (!this.lastActiveOption) return "0";
      return this.$fun.EURNumSegmentation(
        this.$fun.ceil(this.lastActiveOption.price * this.exchangeRate),
      );
    },
    unitPriceRmb() {
      if (!this.lastActiveOption) return "0";
      return this.$fun.RMBNumSegmentation(this.lastActiveOption.price);
    },
    totalPriceEur() {
      return this.$fun.EURNumSegmentation(
        this.$fun.ceil(
          this.orderParent.oneGoodsOptionTotalPrice * this.exchangeRate,
        ),
      );
    },
  },
  methods: {
    showInfoIcon(item) {
      if (!item) return false;
      // 亚马逊 FBA 贴标、联合包装需展示说明图标
      return item.id == 12 || item.id == 13;
    },

    setActivePreview(in_optionListitem) {
      const find_data =
        this.optionIntroduction.find((ii) => ii.id == in_optionListitem.id) ||
        {};
      this.lastActiveOption = in_optionListitem;
      this.activeImage = find_data.image || "";
      this.activeVideo = find_data.video || "";
      this.active_name_translate = this.$fun.optionDisplayName(
        in_optionListitem,
      );
      this.$forceUpdate();
    },

    onOptionCardClick(in_optionListitem) {
      this.setActivePreview(in_optionListitem);
    },

    // 点击 info 图标时同步更新右侧预览
    onInfoIconClick(in_optionListitem) {
      this.setActivePreview(in_optionListitem);
    },

    onOptionCheckChange(in_optionListitem) {
      this.orderParent.setOptionsNum(in_optionListitem, this.parentData.num);
      this.orderParent.setOneGoodsOptionTotalPrice();
      this.setActivePreview(in_optionListitem);
    },

    open(data) {
      this.parentData = data;
      this.lastActiveOption = null;
      this.activeImage = "";
      this.activeVideo = "";
      this.active_name_translate = "";
      const checkedList = this.orderParent.optionList.filter(
        (item) => item.checked,
      );
      if (checkedList.length) {
        this.setActivePreview(checkedList[checkedList.length - 1]);
      }
      this.show = true;
      this.$nextTick(() => {
        this.orderParent.setOneGoodsOptionTotalPrice();
      });
    },

    handleClose(done) {
      this.show = false;
      if (typeof done === "function") {
        done();
      }
    },

    saveOrderOption() {
      if (!this.canEdit) {
        this.show = false;
        return;
      }
      this.orderParent.checkItem.option = [];
      for (var i in this.orderParent.optionList) {
        if (this.orderParent.optionList[i].checked == true) {
          this.orderParent.checkItem.option.push(
            this.orderParent.optionList[i],
          );
        }
      }
      this.parentData.option = JSON.parse(
        JSON.stringify(this.orderParent.checkItem.option),
      );
      this.parentData.accessorialService = false;
      this.show = false;
      this.orderParent.calculateOrder();
    },

    onQuantityInputFocus(event) {
      const input = event && event.target;
      if (!input || input.tagName !== "INPUT") {
        return;
      }
      this.$nextTick(() => {
        input.select();
      });
    },

    // 设置不能为0
    setNumber(neow, optionListitem) {
      if (neow == undefined) {
        optionListitem.num = 1;
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

.optionBox {
  /deep/.el-dialog {
    border-radius: 8px;
    overflow: hidden;

    .el-dialog__header {
      padding: 20px 24px 16px;
      border-bottom: 1px solid #eaecf0;

      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #101828;
      }

      .el-dialog__headerbtn {
        top: 18px;
        right: 18px;
      }
    }

    .el-dialog__body {
      padding: 0;
    }
  }
}

.diaCon {
  display: flex;
  flex-direction: column;
}

.diaMain {
  display: flex;
  align-items: stretch;
  gap: 24px;
  padding: 32px 32px 0;
}

.optionListBox {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0px 20px;
  align-content: start;
  padding-right: 8px;
}

.optionOpt {
  display: flex;
  width: 240px;
  flex-direction: column;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 12px;
  padding: 12px 14px;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s, box-shadow 0.2s;

  &.is-checked {
    border-color: #009246;
    background: #f3faf6;
    box-shadow: 0 0 0 1px rgba(0, 146, 70, 0.12);
    .optionNameBox {
      color: #009246 !important;
    }
  }

  &.is-last-active:not(.is-checked) {
    border-color: #bddbb8;
  }

  .headBox {
    display: flex;
    height: 100%;
    align-items: center;
    gap: 8px;

    .optionNameBox {
      flex: 1;
      min-width: 0;
      font-size: 14px;
      line-height: 16px;
      color: #344054;
      word-break: break-word;
    }

    .infoIcon {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }

    /deep/.el-popover__reference {
      display: inline-flex;
      flex-shrink: 0;
      align-items: center;
      line-height: 0;
    }
  }
}

.quantityRow {
  margin: 8px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 32px;

  .quantityLabel {
    font-size: 14px;
    color: #3d3d3d;
    white-space: nowrap;
  }

  /deep/.el-input-number {
    width: 80px;
    height: 32px;
    .el-input__inner {
      text-align: left;
      padding: 6px 14px;
      height: 32px;
      color: #3d3d3d;
    }
  }
}

.previewPanel {
  flex: 0 0 488px;
  width: 488px;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  overflow: hidden;
  background: #f9f9f9;
}

.previewPlaceholder {
  flex: 1;
  min-height: 360px;
  background: #eceff3;
  border-radius: 12px;
}

.previewMedia {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;

  /deep/.el-carousel {
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
  }

  /deep/.el-carousel__item {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
  }

  /deep/.el-carousel__arrow {
    width: 42px;
    height: 42px;
    font-size: 20px;
    background: rgba(0, 0, 0, 0.2);
    &:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }

  .previewImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .previewImg--placeholder {
    object-fit: contain;
    object-position: center;
    padding: 24px;
    box-sizing: border-box;
    background: #fff;
  }

  .previewVideo {
    width: 100%;
    height: 100%;
  }
}

.previewInfo {
  padding: 24px 0;
  .previewTitle {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #101828;
    margin-bottom: 24px;

    .infoIcon {
      width: 18px;
      height: 18px;
    }
  }

  .previewPrice {
    font-size: 14px;
    line-height: 22px;
    color: #475467;

    .priceEur {
      color: #ffa018;
      font-weight: 600;
    }

    .priceRmb {
      margin-left: 4px;
      color: #ffa018;
    }
  }
}

.diaFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 16px 24px 24px;
  border-top: 1px solid #eaecf0;

  .footerTip {
    flex: 1;
    margin: 0;
    font-size: 14px;
    line-height: 22px;
    color: #667085;
  }

  .footerRight {
    display: flex;
    align-items: center;
    gap: 24px;
    flex-shrink: 0;
  }

  .footerTotal {
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    white-space: nowrap;
    display: flex;
    align-items: center;

    span {
      font-size: 18px;
      font-weight: 700;
      color: #ffa018;
      margin-left: 4px;
    }
  }

  .footerBtns {
    display: flex;
    gap: 12px;

    .el-button {
      min-width: 120px;
      height: 46px;
    }
  }
}

.optionPrement {
  padding: 18px;
  margin: 0 !important;
  width: 310px;

  h3 {
    text-align: left;
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
    color: #2f2f2f !important;
    margin-bottom: 20px;
  }

  p {
    text-align: left;
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 22px;
    color: #000 !important;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.dontcanEdit {
  pointer-events: none;
  opacity: 0.85;
}

.optionCheckInput {
  flex-shrink: 0;
  align-self: center;

  &.el-checkbox {
    display: inline-flex;
    align-items: center;
    height: auto;
    white-space: nowrap;
  }

  /deep/.el-checkbox__label {
    display: none;
    padding: 0;
  }

  /deep/.el-checkbox__input {
    height: 16px;
    line-height: 16px;
    vertical-align: middle;
  }

  /deep/.el-checkbox__inner {
    width: 16px;
    height: 16px;
    border-radius: 4px;

    &::after {
      height: 7px;
      left: 5px;
      top: 2px;
      width: 3px;
    }
  }
}
</style>
